export const printDate = date => {
  const formattedDate = new Date(date);
  if (!date || !formattedDate) {
    return "";
  } else {
    return formattedDate.toLocaleString();
  }
};

/**
 * Uncapitalize the first letter of a string
 * @param {string} str
 * @returns {string | undefined}
 */
export const uncapitalizeFirstLetter = str => {
  if (!str) {
    return;
  }

  return str.charAt(0).toLowerCase() + str.slice(1);
};

/**
 * Check if an entitlement is a NVivo trial that should not allow deactivation/unassign
 * @param {Object} entitlement - The entitlement object
 * @param {string} entitlement.productId - Product ID
 * @param {string} entitlement.productName - Product name
 * @param {boolean} entitlement.isTrial - Whether it's a trial
 * @returns {boolean} True if it's a NVivo trial that should be restricted
 */
export const isRestrictedNVivoTrial = entitlement => {
  if (!entitlement || !entitlement.isTrial) {
    return false;
  }

  // Check for NVivo products by productId or productName
  const nvivoproductIds = [
    "nvivo",
    "nvivo-collaboration",
    "nvivo-nbox",
    "nvivo-transcription"
  ];
  const isNVivoProduct =
    nvivoproductIds.includes(entitlement.productId) ||
    (entitlement.productName &&
      entitlement.productName.toLowerCase().includes("nvivo"));

  return isNVivoProduct && entitlement.isTrial;
};
